import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Button } from '@/design/components';
import { useSettings } from '@/access/SettingsContext';

/**
 * ה QR שהמנהל מציג לעובד. נוצר כ SVG כדי שיישאר חד גם בהדפסה
 * ובהגדלה על מסך, ובצבעי המותג.
 */
export function QrPoster({ url, onClose }: { url: string; onClose: () => void }) {
  const { brand } = useSettings();
  const [svg, setSvg] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let active = true;
    void QRCode.toString(url, {
      type: 'svg',
      errorCorrectionLevel: 'M',
      margin: 1,
      color: { dark: '#231f20', light: '#ffffff' },
    }).then((result) => {
      if (active) setSvg(result);
    });
    return () => {
      active = false;
    };
  }, [url]);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="grid gap-4 rounded-lg border border-line bg-raised p-4 shadow-card">
      <div className="grid gap-1">
        <h2 className="m-0 font-display text-display-m font-semibold">
          סרקו כדי להירשם ל {brand.app_title}
        </h2>
        <p className="m-0 text-body-sm text-muted">
          העובד/ת סורק/ת עם מצלמת הטלפון, ממלא/ת פרטים, ואתם מאשרים כאן.
        </p>
      </div>

      {svg ? (
        <div
          className="mx-auto w-full max-w-64"
          role="img"
          aria-label="קוד QR להרשמה"
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      ) : (
        <div className="mx-auto size-64 animate-pulse rounded-md bg-olive-soft" aria-hidden="true" />
      )}

      <p className="m-0 break-all text-center text-body-sm text-muted" dir="ltr">
        {url}
      </p>

      <div className="flex flex-wrap gap-2">
        <Button variant="secondary" onClick={() => void copy()}>
          {copied ? 'הקישור הועתק' : 'העתקת קישור'}
        </Button>
        <Button variant="secondary" onClick={() => window.print()}>
          הדפסה
        </Button>
        <Button variant="ghost" onClick={onClose}>
          סגירה
        </Button>
      </div>
    </div>
  );
}
